export class LicenseFrequency {
    public static None: string = '';
    public static Monthly: string = $localize`Monthly`;
    public static Annually: string = $localize`Annually`;
}

export type LicenseFrequencyType = keyof typeof LicenseFrequency;

export enum LicenseFrequencyInt {
    Monthly = 0,
    Annually = 1
}
